import { OfferLinkDetailForm } from "components/Forms/OfferLinkDetailForm/OfferLinkDetailForm.tsx";

export const UniqueLink = () => {
    return <OfferLinkDetailForm />;
};
